export enum FeatureTypes {
  ACCOUNT = 'feature-account'
}

export const isFeatureEnable = (feature: FeatureTypes): boolean => {
  const searchParams = new URLSearchParams(location.search);
  return searchParams.get(feature) === 'true';
};
